import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0016',
    ecrans: ['00-2'],
    params: [
        'id',
        '?discleintgen',
        '?vecdistypdis_def_dispo',
        '?disdat'
    ]
});
